import { Badge } from '@wix/design-system';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const BrokerTakenBadge = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(Badge, {
    skin: "neutralLight",
    size: "small",
    uppercase: false
  }, t('domain_search_gate.results.searched_domain.status.broker.badge'));
};
//# sourceMappingURL=BrokerTakenBadge.js.map